import 'bulma/css/bulma.css';
import './assets/main.css';
import 'element-plus/dist/index.css'

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import piniaPersistedstate from 'pinia-plugin-persistedstate';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
// import { Home, Calendar, Users, Settings, Ticket  } from 'lucide-vue-next';
import { library } from '@fortawesome/fontawesome-svg-core'
import App from './App.vue';
import router from './router';
import ElementPlus from 'element-plus'
import es from 'element-plus/es/locale/lang/es'
import "vue-data-ui/style.css"
import moment from 'moment-timezone';
import 'moment/locale/es';
import VueTheMask from 'vue-the-mask';

import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'

moment.locale('es');
moment.tz.setDefault(Intl.DateTimeFormat().resolvedOptions().timeZone);

library.add(fas,fab,far);

const app = createApp(App);
const pinia = createPinia();
pinia.use(piniaPersistedstate);
app.provide('$moment', moment);

// app.component('IconHome', Home)
// app.component('IconCalendar', Calendar)
// app.component('IconUsers', Users)
// app.component('IconSettings', Settings)
// app.component('IconTicket', Ticket)

// Agregar función goBack global
app.config.globalProperties.$goBack = function() {
    if (window.history.length > 1) {
        router.go(-1);
    } else {
        router.push('/');
    }
};

app.use(pinia);
app.use(router)
.component("font-awesome-icon",FontAwesomeIcon)

.use(ElementPlus,{
    locale: es,
})
.use(VueTheMask)

router.isReady().then(() => {
    app.mount('#app');
});
